const secretKey = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;

const SALT_LEN = 16;
const IV_LEN = 12;

async function deriveKey(salt) {
  const enc = new TextEncoder();
  const keyMaterial = await crypto.subtle.importKey(
    'raw',
    enc.encode(secretKey),
    'PBKDF2',
    false,
    ['deriveKey']
  );
  return crypto.subtle.deriveKey(
    { name: 'PBKDF2', salt, iterations: 100000, hash: 'SHA-256' },
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  );
}

export const encrypt = async (data) => {
  const salt = crypto.getRandomValues(new Uint8Array(SALT_LEN));
  const iv = crypto.getRandomValues(new Uint8Array(IV_LEN));
  const key = await deriveKey(salt);
  const enc = new TextEncoder();
  const ciphertext = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    enc.encode(JSON.stringify(data))
  );
  const buf = new Uint8Array(SALT_LEN + IV_LEN + ciphertext.byteLength);
  buf.set(salt, 0);
  buf.set(iv, SALT_LEN);
  buf.set(new Uint8Array(ciphertext), SALT_LEN + IV_LEN);
  return btoa(String.fromCharCode(...buf));
};

export const decrypt = async (data) => {
  try {
    const raw = Uint8Array.from(atob(data), c => c.charCodeAt(0));
    const salt = raw.slice(0, SALT_LEN);
    const iv = raw.slice(SALT_LEN, SALT_LEN + IV_LEN);
    const ciphertext = raw.slice(SALT_LEN + IV_LEN);
    const key = await deriveKey(salt);
    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv },
      key,
      ciphertext
    );
    const decryptedString = new TextDecoder().decode(decrypted);
    if (!decryptedString || decryptedString.trim() === '') {
      return null;
    }
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error("Decryption Error:", error);
    return null;
  }
};
